(function () {
  function initTopbar(section) {
    if (!section) return;

    const benefitsContainer = section.querySelector('.tuya-topbar__benefits');
    if (!benefitsContainer) return;

    const benefits = benefitsContainer.querySelectorAll('.tuya-topbar__benefit');
    if (benefits.length <= 1) return;

    let currentIndex = 0;
    let intervalId = null;
    const intervalTime = 4000;

    function showBenefit(index) {
      benefits.forEach((benefit, i) => {
        if (i === index) {
          benefit.classList.add('active');
          benefit.setAttribute('aria-hidden', 'false');
        } else {
          benefit.classList.remove('active');
          benefit.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function nextBenefit() {
      currentIndex = (currentIndex + 1) % benefits.length;
      showBenefit(currentIndex);
    }

    function startAutoPlay() {
      if (window.innerWidth <= 767) {
        if (!intervalId) {
          showBenefit(currentIndex);
          intervalId = setInterval(nextBenefit, intervalTime);
        }
      } else {
        stopAutoPlay();
      }
    }

    function stopAutoPlay() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
      benefits.forEach(benefit => {
        benefit.classList.remove('active');
        benefit.removeAttribute('aria-hidden');
      });
    }

    startAutoPlay();
    window.addEventListener('resize', startAutoPlay);

    section.tuyaTopbarCleanup = function () {
      stopAutoPlay();
      window.removeEventListener('resize', startAutoPlay);
    };
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.tuya-topbar').forEach(initTopbar);
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('section-tuya-topbar')) {
      const section = event.target.querySelector('.tuya-topbar');
      initTopbar(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.classList.contains('section-tuya-topbar')) {
      const section = event.target.querySelector('.tuya-topbar');
      if (section && typeof section.tuyaTopbarCleanup === 'function') {
        section.tuyaTopbarCleanup();
      }
    }
  });
})();
